isGiftFeatureEnabled